/* Veryplants community gallery (2026-09-23).
   Card grid (3 per row on desktop, 2 on phones, set in the section CSS) with a native <dialog> viewer.
   Video sources are attached only when a card is opened; nothing autoplays on page load.
   Second part: sharper Growave Instagram tiles (see below).
   Tracking (2026-09-24): vp_gallery_view, vp_gallery_open, vp_gallery_shop_click, vp_gallery_source_click,
   vp_gallery_follow_click and vp_ig_tile_open, sent through window.vpTrack (GA4 via gtag, Clarity, Shopify customer events). */

/* Growave renders its 320px thumbnails (imageSmall) into tiles that are about 427px wide on desktop, so on a
   Retina screen they are upscaled 2.7x and look soft. The posts payload the widget fetches for the gallery also
   carries imageMedium (640px) and imageLarge (1080px) for every post. This observes that one fetch, remembers
   the sizes per post, and swaps tile images as Growave mounts them (640px for phone tiles, 1080px on desktop). Fail-safe by design: if the payload shape
   changes nothing is swapped, and if a large image fails to load the small one is restored. */
(function () {
  'use strict';
  if (!window.fetch || !window.MutationObserver || window.__vpGwSharpen) return;
  window.__vpGwSharpen = true;
  var map = {};
  var postByImg = window.__vpGwPostByImg = window.__vpGwPostByImg || {};
  var origFetch = window.fetch;
  window.fetch = function (input) {
    var p = origFetch.apply(this, arguments);
    try {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      if (url.indexOf('/instagram/getGalleryPosts') !== -1) {
        p.then(function (res) {
          try { res.clone().json().then(record).catch(function () {}); } catch (e) {}
        }).catch(function () {});
      }
    } catch (e) {}
    return p;
  };
  function record(d) {
    var items = d && d.items;
    if (!items || !items.length) return;
    for (var i = 0; i < items.length; i++) {
      var media = items[i].media || [];
      for (var k = 0; k < media.length; k++) {
        var m = media[k];
        if (m && m.imageSmall && (m.imageLarge || m.imageMedium)) map[m.imageSmall] = { medium: m.imageMedium, large: m.imageLarge };
        if (m && items[i].permalink) { [m.imageSmall, m.imageMedium, m.imageLarge].forEach(function (u) { if (u) postByImg[u] = items[i].permalink; }); }
      }
    }
    upgradeAll();
  }
  function upgrade(img) {
    if (img.dataset.vpHqFailed) return;
    var small = img.getAttribute('src');
    var sizes = small && map[small];
    if (!sizes) return;
    /* 640px covers a phone tile (about 175 CSS px at 3x); desktop tiles (about 427 CSS px at 2x) get 1080px. */
    var need = img.getBoundingClientRect().width * (window.devicePixelRatio || 1);
    var big = (need <= 640 && sizes.medium) ? sizes.medium : (sizes.large || sizes.medium);
    if (!big) return;
    img.addEventListener('error', function () {
      img.dataset.vpHqFailed = '1';
      img.src = small;
    }, { once: true });
    img.src = big;
  }
  function upgradeAll() {
    var imgs = document.querySelectorAll('.gw-instagram-gallery-placeholder img');
    for (var i = 0; i < imgs.length; i++) upgrade(imgs[i]);
  }
  var observed = [];
  var mo = new MutationObserver(function () { upgradeAll(); });
  function watch() {
    var phs = document.querySelectorAll('.gw-instagram-gallery-placeholder');
    for (var i = 0; i < phs.length; i++) {
      if (observed.indexOf(phs[i]) !== -1) continue;
      observed.push(phs[i]);
      mo.observe(phs[i], { childList: true, subtree: true, attributes: true, attributeFilter: ['src'] });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch); else watch();
  document.addEventListener('shopify:section:load', watch);
})();
(function () {
  'use strict';
  /* Shared event helper (also defined in vp-tree-count.js; whichever loads first wins). Sends to every GA4
     property configured through gtag on the page, to Microsoft Clarity, and to Shopify customer events so a
     custom pixel can subscribe. Never throws. */
  if (!window.vpTrack) {
    window.vpTrack = function (name, params) {
      params = params || {};
      try { params.market = params.market || (window.Shopify && window.Shopify.country) || ''; } catch (e) {}
      /* Address every GA4 property the page configures (read from the gtag config calls). Without send_to, one of
         the two properties on veryplants.com ignores custom events and Google Ads remarketing receives them instead. */
      try {
        if (typeof window.gtag === 'function') {
          var ids = [];
          (window.dataLayer || []).forEach(function (x) { if (x && x[0] === 'config' && /^G-/.test(x[1]) && ids.indexOf(x[1]) === -1) ids.push(x[1]); });
          var p = {}; for (var k in params) { if (Object.prototype.hasOwnProperty.call(params, k)) p[k] = params[k]; }
          if (ids.length) p.send_to = ids;
          window.gtag('event', name, p);
        }
      } catch (e) {}
      try { if (typeof window.clarity === 'function') window.clarity('event', name); } catch (e) {}
      try { if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') window.Shopify.analytics.publish(name, params); } catch (e) {}
    };
  }
  function handleOf(url) { var m = (url || '').match(/\/products\/([^/?#]+)/); return m ? m[1] : ''; }
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(root) {
    if (root.dataset.vpGalleryReady) return;
    root.dataset.vpGalleryReady = 'true';
    var dialog = root.querySelector('[data-vp-dialog]');
    var media = root.querySelector('[data-vp-dialog-media]');
    var title = root.querySelector('[data-vp-dialog-title]');
    var creator = root.querySelector('[data-vp-dialog-creator]');
    var shop = root.querySelector('[data-vp-dialog-shop]');
    var source = root.querySelector('[data-vp-dialog-source]');
    var closeBtn = root.querySelector('[data-vp-close]');
    var lastTrigger = null;
    var current = null;

    function clearMedia() {
      if (!media) return;
      var v = media.querySelector('video');
      if (v) { try { v.pause(); } catch (e) {} v.removeAttribute('src'); v.load(); }
      media.innerHTML = '';
    }

    function openCard(card, trigger) {
      if (!dialog || !media) return;
      var dataEl = card.querySelector('[data-vp-card-data]');
      var d = {};
      try { d = JSON.parse(dataEl ? dataEl.textContent : '{}'); } catch (e) { d = {}; }
      clearMedia();
      current = { gallery_item: d.id || '', media_type: d.video ? 'video' : 'photo', product_handle: handleOf(d.productUrl) };
      window.vpTrack('vp_gallery_open', current);
      if (d.video) {
        var v = document.createElement('video');
        v.controls = true; v.playsInline = true; v.preload = 'metadata';
        if (d.poster) v.poster = d.poster;
        v.setAttribute('aria-label', d.label || 'Community video');
        var s = document.createElement('source'); s.src = d.video; s.type = 'video/mp4'; v.appendChild(s);
        if (d.captions) {
          var tr = document.createElement('track'); tr.kind = 'captions'; tr.src = d.captions; tr.srclang = d.captionsLang || 'en'; tr.label = 'Captions'; tr.default = true; v.appendChild(tr);
        }
        media.appendChild(v);
      } else if (d.poster) {
        var img = document.createElement('img');
        img.src = d.poster; img.alt = d.alt || d.label || ''; img.loading = 'eager';
        media.appendChild(img);
      }
      if (title) title.textContent = d.label || '';
      if (creator) { creator.textContent = d.creator || ''; creator.hidden = !d.creator; }
      if (shop) {
        if (d.productUrl) { shop.href = d.productUrl; shop.textContent = d.productTitle ? 'Shop ' + d.productTitle : 'Shop this mix'; shop.hidden = false; }
        else { shop.hidden = true; shop.removeAttribute('href'); }
      }
      if (source) {
        if (d.source) { source.href = d.source; source.hidden = false; } else { source.hidden = true; source.removeAttribute('href'); }
      }
      lastTrigger = trigger;
      if (typeof dialog.showModal === 'function') {
        if (!dialog.open) dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
        dialog.classList.add('vp-gallery__dialog--fallback');
      }
      document.documentElement.classList.add('vp-gallery-open');
      if (closeBtn) closeBtn.focus();
      var vid = media.querySelector('video');
      if (vid) { var p = vid.play(); if (p && p.catch) p.catch(function () {}); }
    }

    function closeDialog() {
      if (!dialog) return;
      if (dialog.open && typeof dialog.close === 'function') dialog.close();
      else dialog.removeAttribute('open');
    }

    root.addEventListener('click', function (e) {
      var opener = e.target.closest ? e.target.closest('[data-vp-open]') : null;
      if (opener && root.contains(opener)) {
        e.preventDefault();
        var card = opener.closest('[data-vp-card]');
        if (card) openCard(card, opener);
        return;
      }
      if (e.target.closest && e.target.closest('[data-vp-close]')) { e.preventDefault(); closeDialog(); }
    });

    /* Tracking listeners run in the capture phase so a widget that stops propagation (Growave) cannot hide the click. */
    root.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      if (t.closest('[data-vp-dialog-shop]')) { window.vpTrack('vp_gallery_shop_click', current || {}); return; }
      if (t.closest('[data-vp-dialog-source]')) { window.vpTrack('vp_gallery_source_click', current || {}); return; }
      if (t.closest('.vp-gallery__follow a')) { window.vpTrack('vp_gallery_follow_click', {}); return; }
      var tile = t.closest('.gw-instagram-gallery-placeholder .gw-ig-post-card');
      if (tile) {
        var tiles = Array.prototype.slice.call(root.querySelectorAll('.gw-instagram-gallery-placeholder .gw-ig-post-card'));
        var img = tile.querySelector('img');
        var post = img ? ((window.__vpGwPostByImg || {})[img.getAttribute('src')] || '') : '';
        window.vpTrack('vp_ig_tile_open', { tile_position: tiles.indexOf(tile) + 1, ig_post: post });
      }
    }, true);

    /* One view per page load once 40% of the section is on screen: the denominator for open and click rates. */
    if ('IntersectionObserver' in window) {
      var seen = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) { window.vpTrack('vp_gallery_view', { curated_items: root.querySelectorAll('[data-vp-card]').length }); seen.disconnect(); break; }
        }
      }, { threshold: 0.4 });
      seen.observe(root);
    }

    if (dialog) {
      dialog.addEventListener('click', function (e) {
        /* click on the backdrop (outside the inner panel) closes */
        if (e.target === dialog) closeDialog();
      });
      dialog.addEventListener('close', function () {
        clearMedia();
        document.documentElement.classList.remove('vp-gallery-open');
        if (lastTrigger && lastTrigger.focus) lastTrigger.focus();
      });
      dialog.addEventListener('cancel', function (e) { e.preventDefault(); closeDialog(); });
      dialog.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); e.stopPropagation(); closeDialog(); }
      });
    }
  }

  function boot() {
    var roots = document.querySelectorAll('[data-vp-gallery]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
